// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"communityEvents-module--wrapper--2qP59","disabled":"communityEvents-module--disabled--2Mcx2","dayofweek":"communityEvents-module--dayofweek--YD2I5"};